import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { SessionUtils, LoggerUtils } from '@ocean/utils'
import { LoginType } from 'types'
import { AppThunk } from 'store'
import { ApiAction, createApiAction } from 'api'
import { UserUtils } from 'utils'
import { userLoggedOut } from 'core/session/slices/session'
import { redirectToSta } from 'core/staIntegration/slices/staIntegration'
import { getAccount } from 'modules/Auth/api/authService'
import { AccountTypes } from 'modules/Auth/types'
import { MobileNativeRedirectParams } from 'modules/redirects/MobileNativeRedirect/types'
import { MobileNativeRedirectState, ApiMobileNativeAccountResponse } from './types'

const initialState: MobileNativeRedirectState = {
  account: {},
}

const mobileNativeRedirectSlice = createSlice({
  name: 'mobileNativeRedirect',
  initialState,
  reducers: {
    accountLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiMobileNativeAccountResponse>>
    ) {
      state.account = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { accountLoaded } = mobileNativeRedirectSlice.actions

export default mobileNativeRedirectSlice.reducer

const handleUserAuthentification =
  (response: ApiMiddlewarePayload<ApiMobileNativeAccountResponse>): AppThunk =>
  async dispatch => {
    const { error, result } = response
    if (!error && result?.info) {
      const { type } = result.info

      // Check special user and redirect to STA
      if (type === AccountTypes.SpecialUser) {
        LoggerUtils.info('Logged in as SpecialUser')
        dispatch(redirectToSta())
        return
      }

      UserUtils.storeUserAccountInfo(result.info)
    }

    dispatch(accountLoaded(response))
  }

export const authenticateUserFromMobile = (authParams: MobileNativeRedirectParams): ApiAction => {
  const { ost, company, userId } = (authParams || {}) as MobileNativeRedirectParams

  // Save params into Session storage
  SessionUtils.storeSession(ost)
  UserUtils.storeUserLoginParams({
    customer: company,
    userId,
    password: '',
    loginType: LoginType.MobileNative,
  })

  return createApiAction({
    apiCalls: {
      info: getAccount,
    },
    payloadAction: accountLoaded,
    nextAction: handleUserAuthentification,
  })
}
